<template>
  <div>
    <textarea ondrop="return false;" :name="name" @input="onChange()" v-model="textAreaValue"
              :placeholder="placeholder" :style="inlineStyle"
              :class="'input ' + cssClass" :cols="cols" :rows="rows" :maxlength="maxlength"></textarea>
      <div class="sep-4"></div>
      <div class="remaining"  v-if="textAreaValue" :class="remaining<10?'almost-done':''">
        Remaining characters: {{ remaining }}
      </div>

  </div>
</template>

<script>
export default {
  name: "FalconTextArea",
  props: ['name','value', 'placeholder', 'cols', 'rows', 'cssClass', 'maxlength', 'inlineStyle'],
  data() {
    return {
      textAreaValue: ''
    }
  },
  mounted() {
    this.textAreaValue = this.value;
  },
  methods: {
    onChange() {
      this.$emit('input', this.textAreaValue);
    },
    onMouseDown() {
      this.$emit('input', this.textAreaValue);
    },
  },
  computed: {
    remaining() {
      if(!this.textAreaValue){
        return 0;
      }
      return this.maxlength - this.textAreaValue.length;
    }
  },
  watch: {
    value(newValue){
      this.textAreaValue = newValue;
    }
  }
}
</script>

<style scoped>
.remaining {
  font-size: 12px;
  color: #666;
}

.almost-done {
  color: #d76718;
}

</style>
